import $ from "jquery";

function init_select2(id, data = [], placeholder = 'Seleccionar una opción'){
    let target = $('#' + id);
    if (target.hasClass("select2-hidden-accessible")) {
        target.select2('destroy');
    }
    target.empty();

    let list = [{'id': '', 'text': placeholder}, ...data];

    target.select2({
        placeholder: placeholder,
        data: list,
        tags: true,
        tokenSeparators: [','],
        allowClear: true,
        theme: "classic",
        width: '100%'
    });
};

function getProductos(init = false) {
    const bounceType = $('#product_product_type').val();
    const bounceName = $('#bounce_name').val();
    const container = document.getElementById("products-container");
    if (!container) return;
    if (init === true && (undefinedOrNull(bounceType) || bounceType === '')) return;
    const products = JSON.parse(container.dataset.products);
    let result = [];

    const foundType = products.find(p => p.type_name === bounceType);
    if (foundType) {
        result = foundType.list.map(item => ({'id': item.name, 'text': item.name}));
    }

    init_select2('product_name', result, 'Seleccionar producto');
    if(!undefinedOrNull(bounceName)) {
        $('#product_name').val(bounceName).trigger('change');
    }
}

function destroyProductos() {
    if(document.getElementById('products-form')) {
        $(document).off('select2:select', '#product_product_type', getProductos);
        document.removeEventListener('turbolinks:load', setupProductos);
        document.removeEventListener('turbolinks:before-cache', destroyProductos);
    }
}

function setupProductos() {
    if(document.getElementById('products-form')) {
        $(document).on('select2:select change', '#product_product_type', getProductos);
        getProductos(true);
    }
}

document.addEventListener('turbolinks:load', setupProductos);
document.addEventListener('turbolinks:before-cache', destroyProductos);